/**
 * @file: useAiTrialCredits.ts
 * @copyright: (c) 2019-2020 sichuan zhichetech co., ltd.
 */

import { useAiCreditBalance } from '@euler/app/components/ai/overlay/functions/useAiCreditBalance';
import { useAiTrialEndsAt } from '@euler/functions/entitlements/useAiTrialEndsAt';
import { useMemo } from 'react';

export interface AiTrialCredits {
  /** The AI credits left; null until they load, or when they did not. */
  credits: number | null;
}

/**
 * A store trying AI (`useAiTrialEndsAt`), with its credits left, fetched
 * only then; null for any other store.
 */
export function useAiTrialCredits(): AiTrialCredits | null {
  const trying = useAiTrialEndsAt() != null;
  const balance = useAiCreditBalance(trying);
  return useMemo(
    () => (trying ? { credits: balance?.balance ?? null } : null),
    [trying, balance],
  );
}
